'use strict'

// CommonJS + require 避免 webpack 把 THREE.FBXLoader 当成 three 的具名 export 分析
var THREE = require('three')
if (typeof global !== 'undefined') global.THREE = THREE
if (typeof window !== 'undefined') window.THREE = THREE
require('three/examples/js/libs/fflate.min.js')
require('three/examples/js/curves/NURBSUtils.js')
require('three/examples/js/curves/NURBSCurve.js')
require('three/examples/js/loaders/FBXLoader.js')
require('three/examples/js/loaders/OBJLoader.js')
require('three/examples/js/loaders/TGALoader.js')

// Horse_Idle / PolarBear_Idle 等 Maya NURBS 导出：modelMap 里可能是 Group/Line，无 .bind
if (THREE.FBXLoader && THREE.FBXLoader.prototype && THREE.FBXLoader.prototype.parse) {
  var origParse = THREE.FBXLoader.prototype.parse
  THREE.FBXLoader.prototype.parse = function (buffer, path) {
    try {
      return origParse.call(this, buffer, path)
    } catch (err) {
      var msg = err && err.message ? err.message : String(err)
      if (/model\.bind is not a function|morphTargetDictionary|reading 'a'|reading 'curves'|attrName/.test(msg)) {
        if (process.env.NODE_ENV === 'development') {
          console.warn('[FBXLoader] recoverable parse error:', path, msg)
        }
        return new THREE.Group()
      }
      throw err
    }
  }
}

module.exports = {
  FBXLoader: THREE.FBXLoader,
  OBJLoader: THREE.OBJLoader,
  TGALoader: THREE.TGALoader
}



// WEBPACK FOOTER //
// ./src/utils/legacyThreeLoaders.js